import React, { useState, useEffect, useMemo } from "react";
import {
  Input,
  Button,
  message,
  Form,
  Select,
  DatePicker,
  Card,
  Upload,
  Checkbox,
} from "antd";
import Service from "../../service";
import { getIfscRegistryError } from "../../util/ifscValidation";
import IfscBankInfo from "../EmployeeFormSections/IfscBankInfo";
import { useParams, useLocation } from "react-router-dom";
import moment from "moment";
import imageCompression from "browser-image-compression";
import {
  PREDEFINED_FIELDS,
  PREDEFINED_SECTION_NAME,
  SAME_AS_PRESENT_ADDRESS_LABEL,
  PRESENT_ADDRESS_LAST_FIELD,
  PERMANENT_TO_PRESENT_MAP,
} from "../../constants/onboardingPredefinedFields";
import "./Onboarding.css";
import { useDispatch } from "react-redux";
import { showAuthLoader, hideAuthLoader } from "../../appRedux/actions/Auth";
import { GLOBAL_CONFIG } from "../../constants/permission_id";
import { isFieldFilled } from "../../util/fieldFillCheck";

let  API_URL = `${process.env.REACT_APP_API_URL}/uploads/company_image`;

// Max size for non-image documents (PDF/DOC/DOCX). Images are auto-compressed
// before upload, so they aren't capped here. Keep this in sync with the hint
// shown on the upload form.
const MAX_DOC_SIZE_MB = 5;

const UploadDocsCandidate = () => {
  const { companyslug } = useParams();
  const dispatch = useDispatch();
  const { Option } = Select;
  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  let query = useQuery();
  let token = query.get("token");
  const [onBoardemployeeDetails, setonBoardEmployeeDetails] = useState({});
  const [flag, setFlag] = useState(1);
  const [uploadedData, setUploadedData] = useState([]);
  const { TextArea } = Input;
  const { id } = useParams();
  const [footerText, setFooterText] = useState("");

  const [dynamicFields, setDynamicFields] = useState([]);
  const [sections, setSections] = useState([]);
  const [predefinedConfig, setPredefinedConfig] = useState({
    sectionActive: true,
    fieldsActive: {},
    fieldsRequired: {},
    minFieldsRequired: 0,
  });
  const [pendingFiles, setPendingFiles] = useState({}); // Stores File objects by fieldName
  const [rejectedDocTypes, setRejectedDocTypes] = useState([]);
  const [isReuploadRejected, setIsReuploadRejected] = useState(false);

  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [placeinfo, setPlaceinfo] = useState({});
  const [state2List, setState2List] = useState([]);
  const [placeinfo2, setPlaceinfo2] = useState({});
  const [locationData, setLocationData] = useState({
    Country: null,
    State: null,
  });

  const Logo = localStorage.getItem(`LogoUrl_${companyslug}`);

  const [form] = Form.useForm();
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  // Draft persistence. On mobile, tapping a file/camera input backgrounds the
  // tab, and the browser may discard+reload it under memory pressure - wiping
  // everything the candidate typed. sessionStorage survives that reload, so we
  // save the form on every change and restore it on mount. File selections
  // (File objects) can't be serialized, so those still need re-picking, but the
  // tedious text/date/select entry is preserved. Keyed by token so distinct
  // candidate links never collide.
  const draftKey = token ? `onboardingDraft_${token}` : null;

  const saveDraft = (allValues) => {
    if (!draftKey) return;
    try {
      const serializable = {};
      Object.keys(allValues || {}).forEach((key) => {
        const value = allValues[key];
        if (value === undefined) return;
        serializable[key] = moment.isMoment(value)
          ? { __moment: value.toISOString() }
          : value;
      });
      sessionStorage.setItem(draftKey, JSON.stringify(serializable));
    } catch (e) {
      /* ignore quota / serialization errors */
    }
  };

  const restoreDraft = () => {
    if (!draftKey) return;
    try {
      const raw = sessionStorage.getItem(draftKey);
      if (!raw) return;
      const parsed = JSON.parse(raw);
      const restored = {};
      Object.keys(parsed).forEach((key) => {
        const value = parsed[key];
        restored[key] = value && value.__moment ? moment(value.__moment) : value;
      });
      form.setFieldsValue(restored);
    } catch (e) {
      /* ignore */
    }
  };

  const clearDraft = () => {
    if (!draftKey) return;
    try {
      sessionStorage.removeItem(draftKey);
    } catch (e) {
      /* ignore */
    }
  };

  useEffect(() => {
    fetchOnboardingFields();
  }, []);

  useEffect(() => {
    const loadLocationData = async () => {
      try {
        // Import ONLY country (95KB) + state (554KB). The package index also
        // bundles an 8MB city dataset that OOM-crashed iOS Safari on this page
        // (getCitiesOfState eagerly builds ~150k objects), so City is excluded
        // and City/Village is a free-text field instead.
        const [countryMod, stateMod] = await Promise.all([
          import("country-state-city/lib/country"),
          import("country-state-city/lib/state"),
        ]);
        setLocationData({
          Country: countryMod.default,
          State: stateMod.default,
        });
      } catch (err) {
        console.error("Failed to load country-state-city:", err);
      }
    };
    loadLocationData();
  }, []);

  const Getcountry = () => {
    if (locationData.Country) {
      setCountry(locationData.Country.getAllCountries());
    }
  };

  const Getstate = (countryName) => {
    if (!locationData.Country || !locationData.State) return;
    const countryCode = locationData.Country.getAllCountries().find(
      (c) => c.name === countryName
    )?.isoCode;
    if (countryCode) {
      setState(locationData.State.getStatesOfCountry(countryCode));
      form.setFieldsValue({ state: undefined, city: undefined });
    }
  };

  const Getstate2 = (countryName) => {
    if (!locationData.Country || !locationData.State) return;
    const countryCode = locationData.Country.getAllCountries().find(
      (c) => c.name === countryName
    )?.isoCode;
    if (countryCode) {
      setState2List(locationData.State.getStatesOfCountry(countryCode));
      form.setFieldsValue({ state2: undefined, city2: undefined });
    }
  };

  useEffect(() => {
    if (locationData.Country) Getcountry();
  }, [locationData]);

  const fetchOnboardingFields = async () => {
    try {
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: Service.getAllPublicFields(companyslug),
      });
      if (response.data) {
        if (response.data.data) {
          setDynamicFields(response.data.data || []);
        }
        if (response.data.sections) {
          setSections(response.data.sections || []);
        }
        if (response.data.predefinedConfig) {
          setPredefinedConfig({
            sectionActive: response.data.predefinedConfig.sectionActive !== false,
            fieldsActive: response.data.predefinedConfig.fieldsActive || {},
            fieldsRequired: response.data.predefinedConfig.fieldsRequired || {},
            minFieldsRequired: response.data.predefinedConfig.minFieldsRequired || 0,
          });
        }
      }
    } catch (err) {
      console.error("Failed to load onboarding fields:", err);
    }
  };

    const renderField = (field) => {
    const isRejectedField = isReuploadRejected && rejectedDocTypes.includes(field.fieldName);
    const isFieldDisabled = isReuploadRejected && !rejectedDocTypes.includes(field.fieldName);
    const rules = [];
    if (field.required && !isFieldDisabled) {
      rules.push({
        required: true,
        message: `${field.fieldLabel} is required`,
      });
    }
    switch (field.fieldType) {
      case "text":
      case "email":
      case "number":
        return (
          <Form.Item
            key={field.fieldName}
            label={field.fieldLabel}
            name={field.fieldName}
            rules={rules}
          >
            <Input
              type={field.fieldType === "number" ? "number" : "text"}
              placeholder={field.placeholder}
              disabled={isFieldDisabled}
            />
          </Form.Item>
        );
      case "select":
        return (
          <Form.Item
            key={field.fieldName}
            label={field.fieldLabel}
            name={field.fieldName}
            rules={rules}
          >
            <Select placeholder={field.placeholder} disabled={isFieldDisabled}>
              {(field.options || []).map((opt) => (
                <Option key={opt.key} value={opt.value}>
                  {opt.value}
                </Option>
              ))}
            </Select>
          </Form.Item>
        );
      case "date":
        return (
          <Form.Item
            key={field.fieldName}
            label={field.fieldLabel}
            name={field.fieldName}
            rules={rules}
          >
            <DatePicker format="DD-MM-YYYY" disabled={isFieldDisabled} />
          </Form.Item>
        );
      case "file": {
        const selectedFile = pendingFiles[field.fieldName];
        const alreadyUploaded = isRejectedField ? null : uploadedData.find(d => d.doc_type === field.fieldName);
        return (
          <Form.Item
            key={field.fieldName}
            label={field.fieldLabel}
            name={field.fieldName}
            valuePropName="filelist"
            getValueFromEvent={(e) => e.target.files[0]}
            rules={selectedFile || alreadyUploaded ? [] : rules}
          >
            {(!selectedFile && !alreadyUploaded) ? (
              <Input
                type="file"
                accept=".pdf,.doc,.docx,.jpg,.jpeg"
                disabled={isFieldDisabled}
                onChange={(e) =>
                  handleFileChange(e.target.files[0], field.fieldName)
                }
              />
            ) : (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '4px 11px', border: '1px solid #d9d9d9', borderRadius: '2px' }}>
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {selectedFile ? selectedFile.name : (alreadyUploaded ? "Already uploaded" : "")}
                </span>
                {!isFieldDisabled && (
                  <Button
                    type="link"
                    danger
                    size="small"
                    onClick={() => handleCancelFile(field.fieldName)}
                  >
                    Cancel
                  </Button>
                )}
              </div>
            )}
          </Form.Item>
        );
      }
      default:
        return null;
    }
  };

  // Effective required for a predefined field: admin mandatory/optional override wins.
  const isPredefinedRequired = (field) => {
    const override = predefinedConfig.fieldsRequired?.[field.fieldName];
    return override === undefined ? field.required : override;
  };

  const getPredefinedRules = (field) => {
    const rules = [];
    if (isPredefinedRequired(field)) {
      rules.push({
        required: true,
        message: `${field.fieldLabel} is required`,
      });
    }
    if (field.validationHint === "aadhar") {
      rules.push({
        pattern: /^\d{4}\s?\d{4}\s?\d{4}$|^\d{12}$/,
        message: "Aadhar must be 12 digits (e.g. 1234 1234 1234)",
      });
    }
    if (field.validationHint === "pan") {
      rules.push({
        pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
        message: "Invalid PAN format (e.g. ABCTY1234D)",
      });
      rules.push({ len: 10, message: "PAN must be 10 characters" });
    }
    if (field.validationHint === "pincode") {
      if (isPredefinedRequired(field)) {
        rules.push({
          required: true,
          message: `${field.fieldLabel} is required`,
        });
      }
      rules.push({
        pattern: /^[A-Za-z0-9\s-]{3,10}$/,
        message: "Please enter a valid Pin-code",
      });
    }
    if (field.validationHint === "alphaSpace") {
      rules.push({
        pattern: /^[A-Za-z\s]*$/,
        message: "Only letters and spaces allowed",
      });
      if (field.maxLength) {
        rules.push({
          max: field.maxLength,
          message: `Max ${field.maxLength} characters`,
        });
      }
    }
    if (field.validationHint === "accountNumber") {
      rules.push({
        pattern: /^[0-9]*$/,
        message: "Only numbers allowed",
      });
      rules.push({
        min: 9,
        max: 18,
        message: "Account number must be 9–18 digits",
      });
    }
    if (field.validationHint === "ifsc") {
      rules.push({
        pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/i,
        message: "Invalid IFSC format (e.g. ABCD0123456)",
      });
      rules.push({
        validator: async (_, value) => {
          const registryError = await getIfscRegistryError(value, { candidate: true });
          if (registryError) throw new Error(registryError);
        },
      });
    }
    if (field.validationHint === "chequeNumber") {
      rules.push({
        pattern: /^[0-9]*$/,
        message: "Only numbers allowed",
      });
    }
    return rules;
  };

  const renderPredefinedField = (field) => {
    const rules = getPredefinedRules(field);
    const isFile = field.fieldType === "file";
    const selectedFile = pendingFiles[field.fieldName];
    const isRejectedField = isReuploadRejected && rejectedDocTypes.includes(field.fieldName);
    const isFieldDisabled = isReuploadRejected && !rejectedDocTypes.includes(field.fieldName);
    const alreadyUploaded = isRejectedField ? null : uploadedData.find(
      (d) => d.doc_type === field.fieldName
    );

    if (field.fieldType === "select") {
      return (
        <Form.Item
          key={field.fieldName}
          label={field.fieldLabel}
          name={field.fieldName}
          rules={isFieldDisabled ? [] : rules}
        >
          <Select placeholder={`Select ${field.fieldLabel}`} disabled={isFieldDisabled}>
            {(field.options || []).map((opt) => (
              <Option key={opt.value} value={opt.value}>
                {opt.key || opt.value}
              </Option>
            ))}
          </Select>
        </Form.Item>
      );
    }
    if (field.fieldType === "date") {
      const isDOB = field.fieldName?.toLowerCase().includes("birthdate") || field.fieldName?.toLowerCase().includes("dob") || field.fieldName?.toLowerCase().includes("date_of_birth");
      const isDOJ = field.fieldName?.toLowerCase().includes("joining") || field.fieldName?.toLowerCase().includes("doj") || field.fieldName?.toLowerCase().includes("date_of_joining");
      
      return (
        <Form.Item
          key={field.fieldName}
          label={field.fieldLabel}
          name={field.fieldName}
          rules={isFieldDisabled ? [] : rules}
        >
          <DatePicker
            format="DD-MM-YYYY"
            disabled={isFieldDisabled}
            defaultPickerValue={isDOB ? moment().subtract(25, "years") : undefined}
            disabledDate={(current) => {
              if (isDOB) {
                return current && current > moment().subtract(15, "years").endOf("day");
              }
              if (isDOJ) {
                const dobValue = form.getFieldValue("birthdate") || form.getFieldValue("dob") || form.getFieldValue("date_of_birth");
                return current && (current > moment().endOf("day") || (dobValue && current < dobValue));
              }
              return current && current > moment().endOf("day");
            }}
            style={{ width: "100%" }}
          />
        </Form.Item>
      );
    }
    if (field.fieldType === "checkbox") {
      return (
        <Form.Item
          key={field.fieldName}
          name={field.fieldName}
          valuePropName="checked"
        >
          <Checkbox disabled={isFieldDisabled}>{field.fieldLabel}</Checkbox>
        </Form.Item>
      );
    }
    if (field.fieldType === "textarea") {
      return (
        <Form.Item
          key={field.fieldName}
          label={field.fieldLabel}
          name={field.fieldName}
          rules={isFieldDisabled ? [] : rules}
        >
          <Input.TextArea rows={3} placeholder={field.placeholder} disabled={isFieldDisabled} />
        </Form.Item>
      );
    }
    if (field.fieldName === "country") {
      return (
        <Form.Item
          key={field.fieldName}
          label={field.fieldLabel}
          name="country"
          rules={isFieldDisabled ? [] : rules}
        >
          <Select
            showSearch
            placeholder="Select Country"
            disabled={isFieldDisabled}
            onChange={(name) => {
              setPlaceinfo({ ...placeinfo, country: name });
              Getstate(name);
            }}
            filterOption={(input, option) =>
              (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
            }
          >
            {country?.map((item) => (
              <Option key={item.isoCode} value={item.name}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      );
    }
    if (field.fieldName === "state") {
      return (
        <Form.Item
          key={field.fieldName}
          label={field.fieldLabel}
          name="state"
          rules={isFieldDisabled ? [] : rules}
        >
          <Select
            showSearch
            placeholder="Select State"
            disabled={isFieldDisabled || !placeinfo?.country}
            onChange={(stateVal) => {
              setPlaceinfo({ ...placeinfo, state: stateVal });
              form.setFieldsValue({ city: undefined });
            }}
            filterOption={(input, option) =>
              (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
            }
          >
            {state?.map((item) => (
              <Option key={item.isoCode} value={item.name}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      );
    }
    if (field.fieldName === "country2") {
      return (
        <Form.Item
          key={field.fieldName}
          label={field.fieldLabel}
          name="country2"
          rules={isFieldDisabled ? [] : rules}
        >
          <Select
            showSearch
            placeholder="Select Present Country"
            disabled={isFieldDisabled}
            onChange={(name) => {
              setPlaceinfo2({ ...placeinfo2, country: name });
              Getstate2(name);
            }}
            filterOption={(input, option) =>
              (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
            }
          >
            {country?.map((item) => (
              <Option key={`2-${item.isoCode}`} value={item.name}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      );
    }
    if (field.fieldName === "state2") {
      return (
        <Form.Item
          key={field.fieldName}
          label={field.fieldLabel}
          name="state2"
          rules={isFieldDisabled ? [] : rules}
        >
          <Select
            showSearch
            placeholder="Select Present State"
            disabled={isFieldDisabled || !placeinfo2?.country}
            onChange={(stateVal) => {
              setPlaceinfo2({ ...placeinfo2, state: stateVal });
              form.setFieldsValue({ city2: undefined });
            }}
            filterOption={(input, option) =>
              (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
            }
          >
            {state2List?.map((item) => (
              <Option key={`2-${item.isoCode}`} value={item.name}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      );
    }
    if (isFile) {
      return (
        <Form.Item
          key={field.fieldName}
          label={field.fieldLabel}
          name={field.fieldName}
          valuePropName="filelist"
          getValueFromEvent={(e) => e?.target?.files?.[0]}
          rules={selectedFile || alreadyUploaded ? [] : rules}
        >
          {!selectedFile && !alreadyUploaded ? (
            <Input
              type="file"
              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
              disabled={isFieldDisabled}
              onChange={(e) =>
                handleFileChange(e.target.files?.[0], field.fieldName)
              }
            />
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "4px 11px",
                border: "1px solid #d9d9d9",
                borderRadius: "2px",
              }}
            >
              <span
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {selectedFile
                  ? selectedFile.name
                  : alreadyUploaded
                  ? "Already uploaded"
                  : ""}
              </span>
              {!isFieldDisabled && (
                <Button
                  type="link"
                  danger
                  size="small"
                  onClick={() => handleCancelFile(field.fieldName)}
                >
                  Cancel
                </Button>
              )}
            </div>
          )}
        </Form.Item>
      );
    }
    return (
      <Form.Item
        key={field.fieldName}
        label={field.fieldLabel}
        name={field.fieldName}
        rules={isFieldDisabled ? [] : rules}
        extra={field.validationHint === "ifsc" ? <IfscBankInfo name={field.fieldName} candidate /> : undefined}
      >
        <Input
          placeholder={field.placeholder}
          maxLength={field.maxLength}
          type="text"
          disabled={isFieldDisabled}
        />
      </Form.Item>
    );
  };

  const handleFileChange = async (file, fieldName) => {
    if (!file) return;

    // Validate at attach time, for every file type. Images are compressed here
    // (not at submit) so the stored/uploaded file is already small - this keeps
    // submit fast AND makes the size check run against the real payload. A huge
    // camera photo becomes ~1MB and passes; a large PDF/DOC (or an image that
    // still won't shrink under the cap) is rejected right at the field.
    const isImage = file.type && file.type.startsWith("image/");
    let finalFile = file;

    if (isImage) {
      const hide = message.loading("Processing image…", 0);
      try {
        finalFile = await imageCompression(file, {
          maxSizeMB: 1,
          maxWidthOrHeight: 2000, // keeps ID/document text legible
          useWebWorker: true,
        });
      } catch (e) {
        finalFile = file; // compression failed - fall back to the original
      } finally {
        hide();
      }
    }

    if (finalFile.size > MAX_DOC_SIZE_MB * 1024 * 1024) {
      const sizeMB = (finalFile.size / (1024 * 1024)).toFixed(1);
      message.error(
        `"${file.name}" is too large (${sizeMB} MB). Please upload a file under ${MAX_DOC_SIZE_MB} MB.`
      );
      // Clear the field so the oversized file isn't kept as the field value.
      form.setFieldsValue({ [fieldName]: undefined });
      return;
    }

    setPendingFiles(prev => ({
      ...prev,
      [fieldName]: finalFile
    }));
  };

  const handleCancelFile = (fieldName) => {
    setPendingFiles(prev => {
      const newState = { ...prev };
      delete newState[fieldName];
      return newState;
    });
    // Also remove from uploadedData if it's there
    setUploadedData(prev => prev.filter(item => item.doc_type !== fieldName));
    // Explicitly reset the form field value to prevent session state issues
    form.setFieldsValue({ [fieldName]: undefined });
  };
  


  useEffect(() => {
    // Restore any saved draft AFTER the server prefill resolves, so a reload
    // keeps the candidate's own entries rather than the (mostly empty) prefill.
    getEmployeeDetails().finally(() => restoreDraft());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

   useEffect(() => {
     const slug = companyslug;
      getCompanyData(slug).then((data) => {

        setFooterText(
          `Copyright ${data.companyName} © ${new Date().getFullYear()}`
        );
      });
    }, []);
  
    async function getCompanyData(slug) {
      try {
        const payload = {slug : slug}
        const response = await Service.makeAPICall({
          methodName: Service.postMethod,
          api_url: `${Service.getCompanyMedia}`,
          body : payload,
        });
        return response.data.data;
      } catch (err) {
        console.error("Error fetching company:", err.message);
        return { companyName: "Default Company" };
      }
    }

  const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };
  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 16,
        offset: 8,
      },
    },
  };

  // const Getcountry = async () => {
  //   axios("https://countriesnow.space/api/v0.1/countries/positions")
  //     .then(function (response) {
  //       setCountry(response?.data?.data);
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //     });
  // };

  // const Getstate = async (name) => {
  //   axios
  //     .post("https://countriesnow.space/api/v0.1/countries/states", {
  //       country: name,
  //     })
  //     .then(function (response) {
  //       setState(response?.data?.data?.states);
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //     });
  // };

  // const Getcity = async (state) => {
  //   axios
  //     .post("https://countriesnow.space/api/v0.1/countries/state/cities", {
  //       country: placeinfo?.country,
  //       state: state,
  //     })
  //     .then(function (response) {
  //       setCity(response?.data?.data);
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //     });
  // };

  const getEmployeeDetails = async () => {
    dispatch(showAuthLoader());
    try {
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: `${Service.getEmployeeDetailsByToken}/${token}`,
      });
      if (response.data && response.data.data && (response.data.data.user || response.data.data.length !== 0)) {
        const data = response.data.data;
        const rejected = data.rejectedDocTypes || [];
        const isReupload = !!data.isReuploadRejected;
        setRejectedDocTypes(rejected);
        setIsReuploadRejected(isReupload);

        let { birthdate, initialName, ...userData } = data.user || {};
        setonBoardEmployeeDetails(userData);
        if (data.docs && data.docs.employee_doc) {
          setUploadedData(data.docs.employee_doc);
        }
        const candidate = data.user || {};
        const customFields = candidate.customFields && typeof candidate.customFields === "object" ? candidate.customFields : {};
        const prefill = {
          first_name: candidate.first_name,
          last_name: candidate.last_name,
          ...customFields,
        };
        if (candidate.birthdate) {
          prefill.birthdate = moment(candidate.birthdate);
        } else if (prefill.birthdate && typeof prefill.birthdate === "string") {
          prefill.birthdate = moment(prefill.birthdate);
        }
        if (isReupload && rejected.length > 0) {
          rejected.forEach((key) => delete prefill[key]);
        }
        if (Object.keys(prefill).some((k) => prefill[k] != null && prefill[k] !== "")) {
          form.setFieldsValue(prefill);
        }
        if (isReupload && rejected.length > 0) {
          const clearValues = {};
          rejected.forEach((key) => { clearValues[key] = undefined; });
          form.setFieldsValue(clearValues);
        }
      }
      if (
        response.data &&
        response.data.data.length == 0 &&
        response.data.message.includes("You already submit documents")
      ) {
        setFlag(2);
      }
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(hideAuthLoader());
    }
  };



  const uploadAllPendingFiles = async () => {
    const uploadResults = {};
    const fieldNames = Object.keys(pendingFiles);

    for (const fieldName of fieldNames) {
      // Files in pendingFiles are already validated and (for images) compressed
      // at attach time in handleFileChange, so no processing is needed here.
      const file = pendingFiles[fieldName];

      const formData = new FormData();
      if (fieldName === "latest_photograph" || fieldName === "Latest Photograph") {
        formData.append("attachment", file, "emp_img");
      } else {
        formData.append("attachment", file, "other");
      }

      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.uploadDocs,
        body: formData,
      });

      // A timed-out/failed request resolves to `undefined` (makeAPICall returns
      // error.response, which is absent on network/timeout errors), so guard
      // every hop - otherwise `response.data` throws the cryptic
      // "Cannot read properties of undefined (reading 'data')".
      if (response && response.data && response.data.data) {
        uploadResults[fieldName] = response.data.data;
      } else {
        throw new Error(
          response?.data?.message ||
            `Upload failed for "${fieldName}". Please check your connection and try again.`
        );
      }
    }
    return uploadResults;
  };

  const handleClickSubmit = async (values) => {
    // Client-side UX gate for the section-level "minimum N of M fields" rule.
    // Skips entirely when no section has a minimum set (zero behavior change).
    // The server enforces this authoritatively, so this only needs to be
    // correct for the normal UI flow, not bulletproof against bypass.
    const failingSections = [];
    const predefinedFillState = getPredefinedSectionFillState(values);
    if (predefinedFillState.min > 0 && predefinedFillState.filled < predefinedFillState.min) {
      failingSections.push(PREDEFINED_SECTION_NAME);
    }
    Object.keys(groupedFields).forEach((sectionKey) => {
      const fillState = getCustomSectionFillState(sectionKey, values);
      if (fillState.min > 0 && fillState.filled < fillState.min) {
        failingSections.push(getSectionName(sectionKey));
      }
    });
    if (failingSections.length > 0) {
      message.error(
        `Please fill the minimum required fields in: ${failingSections.join(", ")}`
      );
      return;
    }

    try {
      dispatch(showAuthLoader());

      // First, upload any pending files
      let uploadedFileNames = {};
      try {
        uploadedFileNames = await uploadAllPendingFiles();
      } catch (error) {
        message.error(error.message || "Failed to upload documents");
        dispatch(hideAuthLoader());
        return;
      }

      const reqbody = {
        customFields: {},
        customFieldFiles: {},
      };

      PREDEFINED_FIELDS.forEach((field) => {
        if (field.fieldType === "file") {
          const newFilename = uploadedFileNames[field.fieldName];
          const existingDoc = uploadedData.find(
            (d) => d.doc_type === field.fieldName
          );
          if (newFilename) {
            reqbody.customFieldFiles[field.fieldName] = newFilename;
          } else if (existingDoc) {
            reqbody.customFieldFiles[field.fieldName] = existingDoc.filename;
          }
        } else if (field.fieldType === "date" && values[field.fieldName]) {
          reqbody.customFields[field.fieldName] = values[
            field.fieldName
          ].format("YYYY-MM-DD");
        } else if (field.fieldType !== "checkbox") {
          const v = values[field.fieldName];
          if (v !== undefined && v !== null && v !== "") {
            reqbody.customFields[field.fieldName] = v;
          }
        } else if (field.fieldType === "checkbox") {
          reqbody.customFields[field.fieldName] = Boolean(
            values[field.fieldName]
          );
        }
      });

      dynamicFields.forEach((field) => {
        if (field.fieldType === "file") {
          const newFilename = uploadedFileNames[field.fieldName];
          const existingDoc = uploadedData.find(
            (d) => d.doc_type === field.fieldName
          );
          if (newFilename) {
            reqbody.customFieldFiles[field.fieldName] = newFilename;
          } else if (existingDoc) {
            reqbody.customFieldFiles[field.fieldName] = existingDoc.filename;
          }
        } else if (field.fieldType === "date" && values[field.fieldName]) {
          reqbody.customFields[field.fieldName] = values[
            field.fieldName
          ].format("YYYY-MM-DD");
        } else {
          reqbody.customFields[field.fieldName] = values[field.fieldName];
        }
      });
      const params = id;
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.submiteveryDoc + "/" + token,
        body: reqbody,
      });
      // `response` is undefined when the submit times out or the network drops
      // (makeAPICall returns error.response, absent on those errors). Guard each
      // hop so a failed submit shows a clear message instead of crashing on
      // `response.data` with "Cannot read properties of undefined".
      if (response && response.data && response.data.data) {
        message.success(response.data.message);
        clearDraft();
        setFlag(3);
        dispatch(hideAuthLoader());
      } else {
        message.error(
          response?.data?.message ||
            "Submission failed. Please check your connection and try again."
        );
        dispatch(hideAuthLoader());
      }
    } catch (error) {
      console.log(error);
      message.error("Something went wrong while submitting. Please try again.");
      dispatch(hideAuthLoader());
    }
  };



  const groupedFields = useMemo(() => {
    const groups = {};
    dynamicFields.forEach((field) => {
      const sectionKey = field.sectionKey || "default";
      if (!groups[sectionKey]) {
        groups[sectionKey] = [];
      }
      groups[sectionKey].push(field);
    });
    return groups;
  }, [dynamicFields]);

  const getSectionName = (sectionKey) => {
    const section = sections.find((s) => s.sectionKey === sectionKey);
    return section?.sectionName || sectionKey || "General Information";
  };

  // Resolves whether a single field counts as "filled" for the section-level
  // minimum-fields-to-fill rule. File fields aren't tracked in the Form's own
  // values (they're managed separately via pendingFiles/uploadedData), so they
  // need to be resolved specially rather than through `values`.
  const isFieldValueFilled = (field, values) => {
    if (field.fieldType === "file") {
      const isRejectedField =
        isReuploadRejected && rejectedDocTypes.includes(field.fieldName);
      const selectedFile = pendingFiles[field.fieldName];
      const alreadyUploaded = isRejectedField
        ? null
        : uploadedData.find((d) => d.doc_type === field.fieldName);
      return isFieldFilled(selectedFile || alreadyUploaded, "file");
    }
    return isFieldFilled(values[field.fieldName], field.fieldType);
  };

  const getPredefinedSectionFillState = (values) => {
    const activeFields = PREDEFINED_FIELDS.filter(
      (field) => predefinedConfig.fieldsActive[field.fieldName] !== false
    );
    const filled = activeFields.filter((field) =>
      isFieldValueFilled(field, values)
    ).length;
    return {
      filled,
      pool: activeFields.length,
      min: predefinedConfig.minFieldsRequired || 0,
    };
  };

  const getCustomSectionFillState = (sectionKey, values) => {
    const fields = groupedFields[sectionKey] || [];
    const filled = fields.filter((field) =>
      isFieldValueFilled(field, values)
    ).length;
    const section = sections.find((s) => s.sectionKey === sectionKey);
    return {
      filled,
      pool: fields.length,
      min: section?.minFieldsRequired || 0,
    };
  };

  const renderMinFieldsHint = (fillState) => {
    if (!fillState.min) return null;
    const met = fillState.filled >= fillState.min;
    return (
      <span
        style={{
          marginLeft: 8,
          fontSize: 12,
          fontWeight: 400,
          color: met ? "#8c8c8c" : "#f5222d",
        }}
      >
        ({fillState.filled}/{fillState.min} required)
      </span>
    );
  };

  return (
    <div className="onboarding-candidate">
      <div className="elsner_onboarding_header">
        <div className="logo">
          <a href="/">
            {Logo ? (
              <img alt="Logo" src={`${API_URL}/${Logo}`} onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = GLOBAL_CONFIG.LOGO_WHITE; }}/>
            ) : (
              <img alt="Logo" src={GLOBAL_CONFIG.LOGO_WHITE} />
            )}
          </a>
        </div>
      </div>
      {flag === 1 && (
        <Card title="Upload Documents For Onboarding">
          <div className="employee-details">
            <Form
              name="basic"
              form={form}
              onFinish={handleClickSubmit}
              onValuesChange={(_, allValues) => saveDraft(allValues)}
              {...formItemLayout}
              layout="vertical"
            >
              <div
                style={{
                  marginBottom: "16px",
                  padding: "8px 12px",
                  background: "#f6ffed",
                  border: "1px solid #b7eb8f",
                  borderRadius: "4px",
                  fontSize: "13px",
                  color: "#555",
                }}
              >
                Accepted formats: PDF, DOC, JPG, PNG. Photos are optimized
                automatically; documents (PDF/DOC) must be under {MAX_DOC_SIZE_MB} MB.
              </div>
              <div className="employee-main-information">
                {predefinedConfig.sectionActive && (
                  <Card
                    title={
                      <span>
                        {PREDEFINED_SECTION_NAME}
                        <Form.Item noStyle shouldUpdate>
                          {() =>
                            renderMinFieldsHint(
                              getPredefinedSectionFillState(form.getFieldsValue())
                            )
                          }
                        </Form.Item>
                      </span>
                    }
                    style={{ marginBottom: "20px" }}
                    headStyle={{ backgroundColor: "#f0f2f5", fontWeight: "bold" }}
                  >
                    <div
                      className="onboarding-upload-form-grid"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        gap: "16px",
                        width: "100%",
                      }}
                    >
                      {PREDEFINED_FIELDS.sort(
                        (a, b) => (a.order ?? 0) - (b.order ?? 0)
                      )
                        .filter(
                          (field) =>
                            predefinedConfig.fieldsActive[field.fieldName] !== false
                        )
                        .flatMap((field) => {
                          const col = (
                            <div
                              key={field.fieldName}
                              className="onboarding-upload-form-column"
                              style={{
                                flex: "0 0 calc((100% - 32px) / 3)",
                                width: "calc((100% - 32px) / 3)",
                                minWidth: "200px",
                                boxSizing: "border-box",
                              }}
                            >
                              {renderPredefinedField(field)}
                            </div>
                          );
                          if (field.fieldName === PRESENT_ADDRESS_LAST_FIELD) {
                            return [
                              col,
                              <div
                                key="same-as-present-address"
                                style={{ width: "100%", flex: "0 0 100%", marginBottom: "20px" }}
                              >
                                <Form.Item name="same_as_present_address" valuePropName="checked" noStyle>
                                  <Checkbox
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        const values = {};
                                        PERMANENT_TO_PRESENT_MAP.forEach(({ from, to }) => {
                                          values[from] = form.getFieldValue(to);
                                        });
                                        form.setFieldsValue(values);
                                        const countryVal = values.country;
                                        const stateVal = values.state;
                                        const cityVal = values.city;
                                        if (countryVal) {
                                          setPlaceinfo({ country: countryVal, state: stateVal, city: cityVal });
                                          // Getstate repopulates the permanent State dropdown options and
                                          // clears state/city; restore the copied values afterwards. City is
                                          // now free text, so no city dataset lookup is needed.
                                          Getstate(countryVal);
                                          form.setFieldsValue({ state: stateVal, city: cityVal });
                                        }
                                      }
                                    }}
                                  >
                                    {SAME_AS_PRESENT_ADDRESS_LABEL}
                                  </Checkbox>
                                </Form.Item>
                              </div>,
                            ];
                          }
                          return [col];
                        })}
                    </div>
                  </Card>
                )}

                {dynamicFields.length > 0 && (
                  <div className="dynamic-fields-section" style={{ marginTop: "20px" }}>
                    {Object.keys(groupedFields).map((sectionKey) => (
                      <Card
                        key={sectionKey}
                        title={
                          <span>
                            {getSectionName(sectionKey)}
                            <Form.Item noStyle shouldUpdate>
                              {() =>
                                renderMinFieldsHint(
                                  getCustomSectionFillState(sectionKey, form.getFieldsValue())
                                )
                              }
                            </Form.Item>
                          </span>
                        }
                        style={{ marginBottom: "20px" }}
                        headStyle={{ backgroundColor: "#f0f2f5", fontWeight: "bold" }}
                      >
                        <div
                          className="onboarding-upload-form-grid"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            gap: "16px",
                            width: "100%",
                          }}
                        >
                          {groupedFields[sectionKey].map((field) => (
                            <div
                              key={field.fieldName}
                              className="onboarding-upload-form-column"
                              style={{
                                flex: "0 0 calc((100% - 32px) / 3)",
                                width: "calc((100% - 32px) / 3)",
                                minWidth: "200px",
                                boxSizing: "border-box",
                              }}
                            >
                              {renderField(field)}
                            </div>
                          ))}
                        </div>
                      </Card>
                    ))}
                  </div>
                )}
              </div>
              <Form.Item className="employee-btns" style={{ textAlign: 'center' }}>
                <Button htmlType="submit" type="primary" size="large">
                  Save
                </Button>
              </Form.Item>
            </Form>
          </div>
        </Card>
      )}
      {flag === 2 && (
        <div
          style={{
            color: "red",
            display: "flex",
            justifyContent: "center",
            fontSize: "20px",
            margin: "10px",
          }}
        >
          You have already uploaded the documents
        </div>
      )}
      {flag === 3 && (
        <div
          style={{
            color: "green",
            display: "flex",
            justifyContent: "center",
            fontSize: "20px",
            margin: "10px",
          }}
        >
          Thank you for submitting documents
        </div>
      )}

      <div className="elsner_onboarding_footer">
        <p>{footerText}</p>
      </div>
    </div>
  );
};

export default UploadDocsCandidate;
